import axios from 'axios';
import type { AccountData } from '@/lib/account';

const BASE_URL = `${process.env.VUE_APP_API_ROOT}/accounts`;

interface AllResponse {
  data: AccountData[];
  success: boolean;
}

interface GetResponse {
  data: AccountData;
  success: boolean;
}

interface PostResponse {
  data: { slug: string };
  success: boolean;
}

interface PutResponse {
  data: {
    slug: string;
    role: number;
  };
  success: boolean;
}

interface DeleteResponse {
  success: boolean;
}

export const accountService = {
  async getByToken(): Promise<AccountData> {
    const res = await axios.get<GetResponse>(`${BASE_URL}/token`);

    return res.data.data;
  },
  async getAll(): Promise<AccountData[]> {

    const res = await axios.get<AllResponse>(BASE_URL);
    return res.data.data;
  },

  async getOne(slug: string): Promise<AccountData> {
    const res = await axios.get<GetResponse>(`${BASE_URL}/${slug}`);
    return res.data.data;
  },

  async add(data: AccountData): Promise<string | undefined> {
    const res = await axios.post<AccountData, { data: PostResponse }>(BASE_URL, data);
    return res.data.success ? res.data.data.slug : undefined;
  },

  async update(slug: string, data: AccountData): Promise<string | undefined> {
    const res = await axios.put<AccountData, { data: PutResponse }>(`${BASE_URL}/${slug}`, data);
    return res.data.success ? res.data.data.slug : undefined;
  },

  async delete(slug: string): Promise<boolean> {
    const res = await axios.delete<DeleteResponse>(`${BASE_URL}/${slug}`);
    return res.data.success;
  },
};
